import { Box, BoxProps } from '@mui/material';

type ImageProps = BoxProps<'img'>;

export const Image: React.FC<ImageProps> = (props) => {
  return <Box component="img" {...props} />;
};
